import { CircularProgress, lighten, styled, Typography } from "@mui/material";

export const StyledLoadingComponent = {
    Root: styled("div")(({ theme }) => ({
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    })),
    CircularProgress: styled(CircularProgress)(({ theme }) => ({
        marginBottom: "20px",
        color: lighten(theme.palette.tertiary.main, 0.3),
    })),
    Title: styled(Typography)(({ theme }) => ({
        color: lighten(theme.palette.tertiary.main, 0.3),
    })),
};